import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'budgetFilter'
})
export class BudgetFilterPipe implements PipeTransform {

  transform(items: any[], searchText : string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter(item => {
      if (item.id.toLocaleLowerCase().includes(searchText))
        return true;
      if (item.first_name.toLocaleLowerCase().includes(searchText))
        return true;
      if (item.surname.toLocaleLowerCase().includes(searchText))
        return true;
      return false;
    });
  }

}
